import React from 'react';
import logo from '../images/1694838574272__1___1_-removebg-preview.png';

function Footer() {
    return (
        <div className="rn-footer-area rn-section-gap section-separator">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="footer-area text-center">
                            <div className="logo">
                                <a href="index.html">
                                    <img src={logo} alt="logo" width="60px" />
                                </a>
                            </div>
                            <p className="description mt--30">
                                © 2026. All rights reserved by <a target="_blank" rel="noopener noreferrer" href="https://www.mukhtarzargar.com/">Mukhtar Ahmad Zargar.</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
